import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import AllFeatures from "../../Components/AllFeatures";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function StreamingServers() {
  useEffect(() => {
    document.title = "Streaming Server Hosting - Live, VOD & CDN Powered";
    sal();
  }, []);
  return (
    <>
      <Helmet>
        <title>Streaming Server Hosting - Live, VOD & CDN Powered</title>
        <meta name="description" content="Launch your streaming platform instantly with a high-speed streaming server featuring VOD, CDN delivery, security protection, and expert support." />
        <meta name="keywords" content="Web Streaming Service, Personal Streaming Service, Best Streaming Server, Streaming Server Cost, Best Server For Streaming, Best Stream Server, Live Streaming Server, Open Streaming Server, Self Hosted Streaming, Server For Streaming Media, Server Streaming Open Source, Set Up A Streaming Server, Streaming Server Hosting Cost, Streaming Server Hosting, Media Streaming Server, Stream Server, Streaming Server Windows, Live Stream Server, Streaming Web Server, Web Server Streaming, Streaming-Server, Vod Server" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/streaming-server`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/streaming-server`} />
        <meta property="og:title" content=" Fast Streaming Server Solutions for Finest Content Delivery" />
        <meta property="og:description" content="Get excellent streaming with advanced Streaming Servers, providing high-performance, and scalability for smooth content delivery to a global customer base." />
      </Helmet>
      <section className="banner-bg bg-dark control-panel-banner pt-pb-100-banner">
        <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-7 col-xl-6">
                  <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      Infinitive Host: Where Streaming Wins
                  </span>
                  <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Missed the Climax Again? Not With Our Streaming Server
                  </h1>
                  <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      Imagine the tea was hot, the drama hit so hard that you don’t even blink once… And the stream glitched? Oops. Don’t let that interrupt the climax. Our streaming server keeps every moment alive-hyper-realistic visuals, high speed, and no terrible delays.</p>
                  <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <Link to="/contact-us" className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                          <span className="btn-arrow__text">
                              Get Started
                              <span className="btn-arrow__icon">
                                  <i className="fa-solid fa-arrow-right"></i>
                              </span>
                          </span>
                      </Link>
                  </div>
              </div>
              <div className="col-lg-5 col-xl-6 text-lg-end">
                  <img src="images/missed-the-climax-again.webp" alt="image" className="img-fluid sal-animate" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" />
              </div>
          </div>
        </div>
      </section>

      <div className="container pt-60 pb-100">
          <div className="row">
              <div className="col-12">
                  <div className="bg-grey pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="row g-4 align-items-center">
                          <div className="col-md-10 col-lg-7 col-xl-5">
                              <div className="d-inline-flex align-items-center gap-2 text-primary-16 fade_left mb-4">
                                  <span className="w-2 h-2 rounded-circle bg-primary-16"></span>
                                  <p className="mb-0">Pause the Drama? Sure. </p>
                              </div>
                              <h2 className="mb-10">Pause the Stream? Nahhhh. Total Control in Your Hands.</h2>
                              <ul className="list-unstyled d-flex flex-column gap-3 mb-12">
                                  <li className="d-flex align-items-center gap-2">
                                      <span>
                                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M11.2508 7.125L7.87574 11.25L6.37574 9.75001M15.9382 9C15.9382 12.8314 12.8322 15.9375 9.00074 15.9375C5.16927 15.9375 2.06323 12.8314 2.06323 9C2.06323 5.16852 5.16927 2.0625 9.00074 2.0625C12.8322 2.0625 15.9382 5.16852 15.9382 9Z" stroke="#C1ED00" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"></path>
                                          </svg>
                                      </span>
                                      <p className="fs-18 mb-0">&nbsp;24/7/365 Available Shared Hosting Support</p>
                                  </li>
                                  <li className="d-flex align-items-center gap-2">
                                      <span>
                                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M11.2508 7.125L7.87574 11.25L6.37574 9.75001M15.9382 9C15.9382 12.8314 12.8322 15.9375 9.00074 15.9375C5.16927 15.9375 2.06323 12.8314 2.06323 9C2.06323 5.16852 5.16927 2.0625 9.00074 2.0625C12.8322 2.0625 15.9382 5.16852 15.9382 9Z" stroke="#C1ED00" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"></path>
                                          </svg>
                                      </span>
                                      <p className="fs-18 mb-0">&nbsp;Fast Issue Resolution</p>
                                  </li>
                                  <li className="d-flex align-items-center gap-2">
                                      <span>
                                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M11.2508 7.125L7.87574 11.25L6.37574 9.75001M15.9382 9C15.9382 12.8314 12.8322 15.9375 9.00074 15.9375C5.16927 15.9375 2.06323 12.8314 2.06323 9C2.06323 5.16852 5.16927 2.0625 9.00074 2.0625C12.8322 2.0625 15.9382 5.16852 15.9382 9Z" stroke="#C1ED00" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"></path>
                                          </svg>
                                      </span>
                                      <p className="fs-18 mb-0">&nbsp;Guaranteed 99.9% Uptime</p>
                                  </li>
                              </ul>
                              <Link to="#" className="btn btn-dark d-inline-flex align-items-center gap-3 rounded-pill py-1 pe-1 ps-6 open-live-chat btn-height">
                                  <span className="fs-14 fw-bold">Start Live Chat</span>
                                  <span className="btn_arrow bg-primary-16">
                                      <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M0.939658 15.6471C0.939658 15.6471 9.14426 8.13546 16.5439 1.36078M16.5439 1.36078C11.1984 6.25477 5.21153 1.69664 5.21153 1.69664M16.5439 1.36078C11.1984 6.25477 15.212 12.6196 15.212 12.6196" stroke="#000" strokeWidth="1.87517"></path>
                                      </svg>
                                  </span>
                              </Link>
                          </div>
                          <div className="col-xl-7">
                              <div className="row g-4">
                                  <div className="col-md-6">
                                      <div className="bg-custom-2 px-6 py-8 rounded-4 border border-white border-opacity-10 h-100">
                                          <img src="images/rule-the-live-stream.webp" alt="Image" className="img-fluid mb-5" />
                                          <h6 className="text-white mb-4">Rule the Live Stream</h6>
                                          <p className="text-white text-opacity-75 mb-7">Control every single second. Our live streaming servers follow all your rules.</p>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="bg-custom-2 px-6 py-8 rounded-4 border border-white border-opacity-10 h-100">
                                          <img src="images/stream-without-limits.webp" alt="Image" className="img-fluid mb-5" />
                                          <h6 className="text-white mb-4">Stream Without Limits</h6>
                                          <p className="text-white text-opacity-75 mb-7">Go anywhere, your stream always stays strong with a dedicated streaming server.</p>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="bg-custom-2 px-6 py-8 rounded-4 border border-white border-opacity-10 h-100">
                                          <img src="images/best-stream-stability.webp" alt="Image" className="img-fluid mb-5" />
                                          <h6 className="text-white mb-4">Best Stream Stability</h6>
                                          <p className="text-white text-opacity-75 mb-7">No lags, no interruptions. Just demanded performance with a streaming server that won’t flinch.</p>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="bg-custom-2 px-6 py-8 rounded-4 border border-white border-opacity-10 h-100">
                                          <img src="images/get-million-viewers.webp" alt="Image" className="img-fluid mb-5" />
                                          <h6 className="text-white mb-4">Get Million Viewers</h6>
                                          <p className="text-white text-opacity-75 mb-7">Huge crowd? No issues with our server. Scale seamlessly with a dedicated streaming server.</p>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1 filtered-image" />
                  </div>
              </div>
          </div>
      </div>
    
      <section className="bg-dark pt-100 pb-100 position-relative allfeatures-wrapper">
        <img src="images/service_16_shape_2.png" alt="Image" className="img-fluid position-absolute start-0 bottom-0 pattern-bg-img"></img>
        <div className="pb-40">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8 col-xl-7">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          <span className="section-title-dark style-bg fadeInUp">Features</span>
                            <h2 className="text-white">
                                Say Bye-Bye to “Nearly Perfect”-We Bring the Complete Package
                            </h2>
                            <p className="mb-0 text-white max-text-52 mx-auto text-opacity-75">
                                Streaming from your cozy setup? Wish for positive vibes only. Our streaming server always comes with extra perks that usually keep your content live, crisp, and always on point. Lag who? Regret where? We don’t know.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AllFeatures />
      </section>

      <section className="bg-white pt-100 pb-100">
        <div className="container">
            <div className="row">
                <div className="col-xl-8">
                  <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Perks of Our Streaming Server</span>
                    <h2 className="mb-0">Our Dedicated Streaming Server Plans Do Everything So You Don’t Have To</h2>
                </div>
            </div>
            <div className="pt-40">
                <div className="row g-4">
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3">
                            <img src="images/servers-that-never.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Servers That Never Slack</h5>
                            <p className="text-dark mb-0">UI, CLI, or API-whatever you prefer, our dedicated streaming servers are designed to keep it smooth, quick, and hassle-free.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3">
                            <img src="images/real-time-or-no-time.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Real-Time or No Time Live</h5>
                            <p className="text-dark mb-0">No lags. No delays. With the help of our live stream servers, you keep in touch with your audience, like you're right there.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3">
                            <img src="images/more-crowd.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5"> More Crowd? Bring It On</h5>
                            <p className="text-dark mb-0">Our streaming server automatically scales like magic, keeping all good vibes alive with reduced latency-just 0.05 sec.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3">
                            <img src="images/stream-securely-always.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Stream Securely, Always</h5>
                            <p className="text-dark mb-0">Keep your live streams smooth with DDoS protection that kicks in within no time. No takedowns, nothing-just pure power.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3">
                            <img src="images/clear-calls-anytime.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Clear Calls: Anytime, 24/7</h5>
                            <p className="text-dark mb-0">Stay near, even from miles away. Build smooth video/audio calls into your app with our user-friendly SDKs-no stress, no worries.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3">
                            <img src="images/watch-It-live-all.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Watch It Live, All the Time</h5>
                            <p className="text-dark mb-0">Stay live in real-time. Our streaming server always lets you plug in IP cameras and go live-no interruption, just complete clarity.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

     <section className="pt-100 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Just For Your Target Audience
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Infinitive Host: Because Your Target Audience Deserves Smooth Streaming</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Server Set Up for FREE</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/no-setup-fees-ever.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Just a single click to go live-our whole server setup charges you no money, quick, and flawless.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Protected & Ready</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/protected-in.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Rest freely with the help of our streaming servers that keep out malware, viruses, and all shady stuff.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Support? Always On</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/support-that-never.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Manual 24/7 support that’s real human, no bots-whenever you want it, whether it's midnight or midday.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Scale in a Blink</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/ready-before-you-blink.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Effortlessly scale your live stream in no time to manage millions of viewers without a single glitch.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">We've your Back(Up)</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/level-up-cloud.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Stay hassle-free with auto backups every day, weekly, or monthly-your data, always protected.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Always Up, Never Down</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/forget-whats-downtime.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Every viewer comes for positive vibes, not for constant loading screens-glad this server understands it.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>

        <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/the-secret-way-from-live.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Any Device, Anytime.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                The Secret Way from Live Event to the Viewer’s Device?
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Begin from capturing all the precious live moments to broadcasting across all your audience devices-our streaming server makes it smooth. Just shoot, encode, and stream with the help of our cloud or on-premises setup.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Stream Everywhere
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                One Task: Go Live. One Choice: Our Live Streaming Servers
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Your live streams deserve better than unexpected disconnects. With the help of our live streaming servers, you experience high-speed, always-on performance engineered for all creators who can’t afford to ruin live.
                            </p>
                            <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/one-task-go-live.webp" alt="image" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section className="bg-white pt-100 pb-100">
        <div className="container ">
            <div className="row">
                <div className="col-12">
                    <div className="bg-dark pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="row g-4 g-xl-0 feature-card">
                                <div className="col-xxl-8 feature-card__list m-auto">
                                    <div className="feature-card__is rounded-3">
                                    <div className="mb-4">
                                        <img src="images/ready-set-stream.webp" alt="image" className="img-fluid" />
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-5">
                                <h2 className="text-white">
                                    Ready. Set. Stream.
                                </h2>
                                <p className="mb-8 text-white text-opacity-75">
                                    No Delays. No Takeaways. Just High-Level Streaming Power.

                                </p>
                                <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-4 m-auto btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                    <i className="las la-comments"></i>
                                    </span>
                                    <span className="btn-arrow__text">+91-7737300013
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                    </span>
                                </Link>
                                <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 m-auto mt-sm-0 mt-4 open-live-chat btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                    <i className="las la-comments"></i>
                                    </span>
                                    <span className="btn-arrow__text">Talk to an Expert
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                        <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1" />
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  );
}
